import React from "react";
import Signup_sidebar from "./Signup_sidebar";
import ResetForm from "./ResetForm";
export default function ResetPassword() {
  return (
    <div className="flex h-screen gil-reg">
      {/* First Half - Sidebar (Hidden in Mobile) */}
      <div className="w-[50%] md:w-[50%] lg:w-[50%]  hidden lg:block md:block bg-black">
        <Signup_sidebar></Signup_sidebar>
      </div>

      {/* Second Half - Signup with Google */}
      <div className="w-full md:w-[50%] lg:w-1/2  overflow-auto scrollbar-hidden ">
        <ResetForm />
      </div>
    </div>
  );
}
